/**
 * Bug 82783: an emailed PostIF sign link names the account it was sent to as ?login=. Signing in
 * from that link (PrivateRoute, or "Sign in with a different account") carries the whole link in
 * /signin's ?redirect=, so the intended approver is read from the redirect's own query string.
 * Returns undefined when there is no redirect, it has no query, or ?login= is blank.
 */
export const getIntendedLogin = (searchParams: URLSearchParams): string | undefined => {
  const redirectQuery = searchParams.get("redirect")?.split("?")[1];
  const login = redirectQuery ? new URLSearchParams(redirectQuery).get("login")?.trim() : undefined;
  return login || undefined;
};
